export default __webpack_public_path__ + "static/logo-0ea341cb393151b0f1f1a05fc1deb382.svg";